<script setup lang="ts">
import {computed} from 'vue'

import IconButton from '~/components/button/IconButton.vue'
import {useCopy} from '~/composables/useCopy'
import BcLink from '~/ui/Link/BcLink.vue'

interface IProps {
  hash: string
  type?: string
  hideIcon?: boolean
}

const props = withDefaults(defineProps<IProps>(), {
  type: 'normal'
})

const {copy} = useCopy()

const isShowIcon = computed(() => !props.hideIcon)
const icon = computed(() => {
  if (props.hideIcon) return
  return getIconByType(props.type)
})

const getIconByType = (type: string) => {
  if (type === 'pending') return 'clock'
  return 'exchange-alt'
}
</script>

<template>
  <div class="flex w-full items-center gap-2">
    <BcLink
      class="tnx-link"
      :content="hash"
      :to="routes.getTransactionDetailPageWithTab(hash)"
    >
      <template
        v-if="isShowIcon"
        #prefix
      >
        <FontAwesomeIcon
          v-if="icon"
          :class="['text-primary/40 group-hover:text-primary']"
          class="group-hover:text-primary"
          :icon="icon"
        />
      </template>
    </BcLink>
    <IconButton
      icon="copy"
      @click.prevent="copy(hash)"
    />
  </div>
</template>

<style scoped lang="scss">
.tnx-link {
  @apply text-explorer-blue truncate;
}
</style>